import moment from 'moment';

export default function momentAmsterdamTime(externalDate) {
    if (externalDate) {
        return moment.unix(externalDate).clone().tz('Europe/Amsterdam');
    }
    return moment().add(moment().tz('Europe/Amsterdam').utcOffset(), 'minute');
}
